<ion-item detail (click)="openImage()">
  <ion-thumbnail *ngIf="note.thumbnail && note.thumbnail!=''" slot="start">
    <img [src]="note.thumbnail">
  </ion-thumbnail>
  <ion-label [innerHTML]="note.when" class="ion-text-wrap"></ion-label>
  <ion-text [innerHTML]="note.note" class="ion-text-wrap"></ion-text>
</ion-item>